<template>
  <input ref="select" @focus="handleFocus" />
</template>

<script>
import TomSelect from 'tom-select';
import * as jobOptionsApi from '@/api/jobOptions';

export default {
  emits: ['update:model-value'],
  props: {
    modelValue: {},
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.control = new TomSelect(this.$refs.select, {
        maxItems: 1,
        valueField: 'id',
        labelField: 'label',
        searchField: 'label',
        load: (query, callback) => {
          jobOptionsApi.index({ filter: query }).then(({ options }) => {
            callback(options);
          });
        },
        onChange: value => {
          this.$emit('update:model-value', value);
        },
      });
      if (this.modelValue) {
        jobOptionsApi.show(this.modelValue).then(option => {
          this.control.addOption(option);
          this.control.addItem(option.id);
        });
      }
    },
    handleFocus() {
      this.control.focus();
    },
  },
};
</script>
